/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

export function handleDeselectCard() {
    return function (dispatch) {
        return dispatch({
            type: types.SEARCH_HANDLE_SELECTED_CARD,
            payload: null,
        });
    };
}

export function handleOnClickSearchOnMove(item) {
    return function (dispatch) {
        return dispatch({
            type: types.SEARCH_HANDLE_SEARCH_ON_MOVE,
            payload: item,
        });
    };
}

export function handleSelectCard(item) {
    return function (dispatch) {
        return dispatch({
            type: types.SEARCH_HANDLE_SELECTED_CARD,
            payload: item,
        });
    };
}

export function handleSelectMapFeature(item) {
    return function (dispatch) {
        return dispatch({
            type: types.SEARCH_HANDLE_SELECTED_MAP_FEATURE,
            payload: item,
        });
    };
}

export function setVisibleMapItems(itemIds) {
    return function (dispatch) {
        return dispatch({
            type: types.SET_VISIBLE_MAP_ITEMS,
            payload: itemIds,
        });
    };
}
